<tlk-card>
	<span tlkCardHeader>{{ procedureTitle$ | async }}</span>
	<div tlkCardContent>
		<div class="intuitive-card-content">
			<rx-procedure-type-control
				class="intuitive-inline-controls"
				[id]="'invisalignType'"
			></rx-procedure-type-control>

			<rx-select
				*ngIf="(treatmentStageState$ | async)?.isEnabled"
				class="intuitive-inline-controls"
				[id]="'treatmentStage'"
				[label]="'OrderSection.TreatmentStage' | translate"
				[formControl]="treatmentStageControl"
				[options]="procedureTreatmentStages$ | async"
				[isCancellable]="true"
				[isDisabled]="(isReadOnly$ | async)"
				name="treatmentStageControl"
				(disableChangeEvent)="clearControl(treatmentStageControl)"
			>
			</rx-select>
			<ng-container *ngIf="(currentAlignerIdState$ | async)?.isVisible && hasTreatmentStageValue">
				<tlk-incremental-number-input
					*ngIf="(currentAlignerIdState$ | async)?.isEnabled"
					class="intuitive-inline-controls"
					[label]="('OrderSection.CurrentAligner' | translate) + '#:'"
					[helperText]="'InvisalignDetailsSection.CurrentAlignerIdHint' | translate: { minValue: 0, maxValue: maxAlignerNumberValue }"
					[formControl]="currentAlignerIdControl"
					[isDisabled]="isReadOnly$ | async"
					name="currentAlignerIdControl"
					[min]="0"
					[max]="maxAlignerNumberValue"
				></tlk-incremental-number-input>

				<tlk-text-input
					*ngIf="!(currentAlignerIdState$ | async)?.isEnabled"
					class="intuitive-inline-controls"
					[label]="('OrderSection.CurrentAligner' | translate) + '#:'"
					[placeholder]="('OrderSection.CurrentAligner' | translate) + '#:'"
					[formControl]="currentAlignerIdControl"
					[isDisabled]="true"
					name="currentAlignerIdControl"
				></tlk-text-input>
			</ng-container>
		</div>
	</div>
</tlk-card>
